import { createContext } from 'react';

const usePRDcontext = createContext();
export default usePRDcontext;
